export enum BooleanChoice {
  YES = 'Yes',
  NO = 'No'
}
